import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { toast } from 'react-toastify'
import APIS from '../../constant/EndPoint'
import useGetHook from '../../customHooks/useGetHook'
import { useSearchParams } from 'react-router-dom'

export default function OrderMenu(props: any) {
  const [searchParams, setSearchParms] = useSearchParams()

  const handleButtonClick = (type: string) => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",")
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first")
      return
    }
    props?.setOrderActionMenu(true)
    props?.setActionType(type)
  }
  const { data: userProfileType } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER_PROFILE}`,
    params: {},
  });

  return (
    <div className=" top-16 text-right">
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button className="inline-flex w-full justify-center rounded-md text-primary px-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
            Action
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            {userProfileType?.is_staff ?
              <>
                <div className="px-1 py-1 ">
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        onClick={() => handleButtonClick("Change Status")}
                        className={`${active ? 'bg-primary text-white' : 'text-gray-900'
                          } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                      >
                        Change Status
                      </button>
                    )}
                  </Menu.Item>
                </div>
                <div className="px-1 py-1 ">
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        onClick={() => handleButtonClick("Assign To Rider")}
                        className={`${active ? 'bg-primary text-white' : 'text-gray-900'
                          } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                      >

                        Assign To Rider
                      </button>
                    )}
                  </Menu.Item>
                </div>
              </>
              : ""}

            <div className="px-1 py-1">
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => handleButtonClick("Exchange")}
                    className={`${active ? 'bg-primary text-white' : 'text-gray-900'
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  >

                    Exchange
                  </button>
                )}
              </Menu.Item>
            </div>
            <div className="px-1 py-1">
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => handleButtonClick("RTV/Return")}
                    className={`${active ? 'bg-primary text-white' : 'text-gray-900'
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  >
                    RTV/Return
                  </button>
                )}
              </Menu.Item>
            </div>
            {/* <div className="px-1 py-1">
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => handleButtonClick("Extra Mile Charge")}
                    className={`${active ? 'bg-primary text-white' : 'text-gray-900'
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  >

                    Extra Mile
                  </button>
                )}
              </Menu.Item>
            </div> */}
            {/* <div className="px-1 py-1">
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => handleButtonClick("Transit")}
                    className={`${active ? 'bg-primary text-white' : 'text-gray-900'
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  >

                    Transit
                  </button>
                )}
              </Menu.Item>
            </div> */}
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  )
}
